import React, { Component } from 'react';
import { Popover } from 'antd';
import xzs from '../assets/xzs.jpg';
import app from '../assets/app.jpg';

class XZS extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { version, history, manual } = this.props;
        // manual = false
        return (
            <div className="xzs-xf">
                <Popover placement="leftBottom" content={<img src={app} alt="" width="200" height="200" />} trigger="hover">
                    <div className="btn" style={{ background: '#CE0018', border: '1px solid #CE0018' }}>
                        <div>手机</div>
                        <div>版本</div>
                        <div>下载</div>
                    </div>
                </Popover>
                {
                    manual ?
                        (
                            <div className="btn" onClick={() => history.push('/manual')}>
                                <div>使用</div>
                                <div>手册</div>
                            </div>
                        ) : null
                }
                {
                    version ?
                        (
                            <div className="btn" onClick={() => history.push('/update_log')}>
                                <div>版本</div>
                                <div>更新</div>
                                <div>内容</div>
                            </div>
                        ) : null
                }
                <Popover placement="leftBottom" content={<img src={xzs} alt="" width="316" height="431" />} trigger="hover">
                    <div className="btn">
                        <div>微</div>
                        <div>信</div>
                        <div>客</div>
                        <div>服</div>
                    </div>
                </Popover>
            </div>
        );
    }
}

export default XZS;



// WEBPACK FOOTER //
// ./src/components/XZS.jsx